import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { ButtonGroup } from 'common-src/components/base';

import NoteBox from './NoteBox';

const MocaChoice = ({
  label,
  options,
  onChoose,
  disabled = false,
  placeholder = 'Your change',
}) => {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <NoteBox
        label={`${label} note`}
        placeholder={placeholder}
        disabled={disabled}
        onSave={(note) => {
          onChoose('edit', note);
          setEditing(false);
        }}
        onCancel={() => setEditing(false)}
      />
    );
  }

  return (
    <ButtonGroup
      label={label}
      options={options}
      disabled={disabled}
      onSelect={(value) => (value === 'edit' ? setEditing(true) : onChoose(value))}
    />
  );
};

MocaChoice.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChoose: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default MocaChoice;
